// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3T2X0","head":"Table_head__3Nqdc","col":"Table_col__RHYTm"};